import React from "react";

import SubscriptionSummary from "./SubscriptionSummary";

import styles from "./DesktopSubscriptionSummary.module.scss";

const DesktopSubscriptionSummary = () => (
  <div className={styles.container}>
    <p className="gkit-p-20 gkit-bold gkit-m-0">Your Order</p>
    <SubscriptionSummary />
  </div>
);

export default DesktopSubscriptionSummary;
